import React from 'react';
import './index.css';

function HoverBox({ visible, content }) {
  return (
    <div className={`hover-box ${visible ? 'visible' : ''}`}>
      <div className="hover-box-content">{content}</div>
    </div>
  );
}

export default HoverBox;
